
import { portalapi } from 'src/helpers/axios'
import { ErrorService } from "../helpers/errorplugin"
const $log = ErrorService


const getDefaultState = () => {
  return {
    eventtypes: undefined, // event types for mapping description to event table
  }
}

const state = getDefaultState()

const mutations = {
  setEventtypes: function(state, newEventtypes){    
    state.eventtypes = newEventtypes
  },
  reset(state, type){
    Object.assign(state, getDefaultState())
  }
}


const getters = {
  getEventtypes: state => state.eventtypes
}

const actions = {
  setEventtypes: ({dispatch, commit }, payload) => {
    if ( payload != null ) {
      commit("setEventtypes", payload.subscription)
    } else {
      commit("setEventtypes", undefined)
    }
  },
  initialiseEventtype:({dispatch, commit}) => {
    portalapi.get('/myaccount/eventtypes')
    .then((response) => {
      let rd = response.data
      if ( rd?.length>=1 ){
        $log.onDebug("got a list of event types")
        // activeEntitlement
        commit("setEventtypes", rd)
      } else {
        $log.onDebug("myaccount/eventtypes: could not find event types")
        commit("setEventtypes", null)
      }
      
    }, error => {
      $log.onDebug("Failed to get event types:" + JSON.stringify(error))
    })
  
    
  },
  reset({commit}){
    commit('reset')
  }
}
      
export const event = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
  };
    
